import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";

import { AuthService } from "../../../services/authservice";

@Component({
  selector: "not-authorized",
  templateUrl: "not-authorized.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class NotAuthorizedComponent {
  private auth = inject(AuthService);
  protected canImpersonate = signal(false);

  constructor() {
    if (this.auth.isSuperUserRO()) {
      this.canImpersonate.set(true);
    }
  }
}
